import { render, staticRenderFns } from "./AreaPageContainer.vue?vue&type=template&id=77823a9e&scoped=true&"
import script from "./AreaPageContainer.vue?vue&type=script&setup=true&lang=js&"
export * from "./AreaPageContainer.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77823a9e",
  null
  
)

export default component.exports